import { render } from "./LibraryTableComponent.vue?vue&type=template&id=9eb1d48a&scoped=true"
import script from "./LibraryTableComponent.vue?vue&type=script&lang=js"
export * from "./LibraryTableComponent.vue?vue&type=script&lang=js"

import "./LibraryTableComponent.vue?vue&type=style&index=0&id=9eb1d48a&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9eb1d48a"]])

export default __exports__